<div class="panel-container">
    <div class="panel-title-wrapper">
        <mat-icon svgIcon="approval" />
        <div class="panel-title">
            {{ 'version-history.panel.approve.title' | translate }}
        </div>
    </div>
    <div class="change-container" *ngFor="let approver of changes.approved">
        <div class="approved-title">
            {{ 'version-history.panel.approve.approved.title' | translate: { version: version } }}
        </div>
        <div class="status-subtitle">
            <div>
                {{ 'version-history.panel.approve.approved.subtitle' | translate }}
            </div>
            <div [ngStyle]="{ color: getStringColor(approver) }">
                {{ approver }}
            </div>
        </div>
    </div>
    <div class="change-container" *ngFor="let rejection of changes.rejected">
        <div class="rejected-title">
            {{ 'version-history.panel.approve.rejected.title' | translate: { version: version } }}
        </div>
        <div style="word-break: break-word">"{{ rejection.reason }}"</div>
        <div class="status-subtitle">
            <div>
                {{ 'version-history.panel.approve.rejected.subtitle' | translate }}
            </div>
            <div [ngStyle]="{ color: getStringColor(rejection.by) }">
                {{ rejection.by }}
            </div>
        </div>
    </div>
</div>
